/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 1);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_js__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_default_less__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__styles_default_less___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__styles_default_less__);
/* eslint-disable */



(function (global) {
  function extractCodeFromHash() {
    if (window.location.hash) {
      var code = (window.location.hash.match(/^#code=(\d+)/) || []).pop();
      if (code) {
        window.document.querySelector('#code').value = global.formatCode(code);
      }
    }
  };

  function getToken(code, callback) {
    var req = new XMLHttpRequest();
    req.addEventListener('load', function () {
      if (this.status !== 200) {
        alert('Unknown code entered. Please try again.');
      } else {
        try {
          callback(JSON.parse(this.responseText).token);
        } catch (e) {
          alert('Unknown error occured while parsing authentication token. Please contact support.');
        }
      }
    });
    req.addEventListener('error', function () {
      alert('Unknown error occured while attempting to contact pairing code server. Please contact support.');
    });
    req.open('GET', __WEBPACK_IMPORTED_MODULE_0__constants_js__["a" /* PAIRING_ENDPOINT */] + '/api/code/' + parseInt(code, 10));
    req.send();
  }

  function establishConnection(code, onSuccess, onError) {
    getToken(code, function (token) {
      var decodedTokenBody, req;

      try {
        decodedTokenBody = JSON.parse(atob(token.split('.')[1]));
        if (!decodedTokenBody.iss || !decodedTokenBody.ssid) {
          throw new Error();
        }
      } catch (e) {
        return onError('Invalid authentication token supplied. Please contact support.');
      }

      req = new XMLHttpRequest();
      req.addEventListener('load', function () {
        if (this.status === 201) {
          onSuccess();
        } else if (this.status === 200) {
          onError('This device is already paired.');
        } else {
          onError('Could not establish pairing. Please contact support.');
        }
      });
      ['error', 'timeout'].forEach(function (eventName) {
        req.addEventListener(eventName, function () {
          onError('Could not establish pairing. Please try to connect to the "' + decodedTokenBody.ssid + '" WiFi network and refresh this page.');
        });
      });
      req.open('POST', decodedTokenBody.iss + '/pair');
      req.timeout = __WEBPACK_IMPORTED_MODULE_0__constants_js__["b" /* PAIRING_TIMEOUT */];
      req.setRequestHeader('Authorization', 'Bearer ' + token);
      req.send();
    });
  }

  function connect(textualCode, hasAcceptedTos) {
    if (!hasAcceptedTos) {
      alert('Please accept the Terms of Service before connecting');
      return;
    }

    var code = (textualCode || '').replace(/[^\d]/g, '');

    if (code.length === __WEBPACK_IMPORTED_MODULE_0__constants_js__["c" /* CODE_LENGTH */]) {
      global.establishConnection(code, function () {
        document.getElementById('entry').style.display = 'none';

        var connectedBlock = document.getElementById('connected');
        connectedBlock.style.display = 'block';
        window.scrollTo(0, 0);
      }, function (error) {
        alert(error);
      });
    }
  }

  global.formatCode = function (code) {
    return ((code || '').replace(/[^\d]/g, '').match(/\d{1,3}/g) || []).join(' ');
  };

  global.reformatInput = function (input) {
    var currentValue = input.value,
        caretPosition = input.selectionStart;

    if (caretPosition === currentValue.length || currentValue.replace(/\s/g, '').length === __WEBPACK_IMPORTED_MODULE_0__constants_js__["c" /* CODE_LENGTH */]) {
      input.value = global.formatCode(currentValue);
      caretPosition += input.value.length - currentValue.length;
    }

    setTimeout(function () {
      input.selectionStart = input.selectionEnd = caretPosition;
    }, 0);
  };

  global.establishConnection = establishConnection;
  global.connect = connect;

  window.document.addEventListener('DOMContentLoaded', extractCodeFromHash);
  window.addEventListener('hashchange', extractCodeFromHash);
})(window.sonifi || (window.sonifi = {}));

/***/ }),
/* 1 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_bootstrap__ = __webpack_require__(0);


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PAIRING_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return PAIRING_TIMEOUT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CODE_LENGTH; });
/* global __ENV_STAYCAST_PAIRING_ENDPOINT__ */

/**
 * The endpoint to use when attempting to communicate with the pairing server.
 *
 * @constant
 *
 **/
// export const PAIRING_ENDPOINT = __ENV_STAYCAST_PAIRING_ENDPOINT__ || 'http://localhost:3000/';
var PAIRING_ENDPOINT = 'https://cast-staging.sonifi.com';

/**
 * The amount of time to wait for a pairing attempt.
 *
 * @constant
 *
 **/
var PAIRING_TIMEOUT = 1000 * 5;

/**
 * The length of a valid code.
 *
 * @constant
 *
 **/
var CODE_LENGTH = 9;

/***/ }),
/* 3 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// scripts/app.js